import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	apps: null,
	errorMessage: null,
	users: null,
	navigation: null,
};

export default function appsReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.LOAD_APPS_SUCCESS:
			return Object.assign({}, state, {
				apps: action.apps,
			});
		case ActionTypes.LOAD_USERS_SUCCESS:
			return Object.assign({}, state, {
				users: action.users,
			});
		case ActionTypes.LOAD_APPS_FAIL:
			return Object.assign({}, state, {
				errorMessage: action.message,
			});
		case ActionTypes.EDIT_APP_NAVIGATION_SUCCESS:
			return Object.assign({}, state, {
				navigation: action.navigation,
			});
		case ActionTypes.LOAD_APP_NAVIGATION_SUCCESS:
			return Object.assign({}, state, {
				navigation: action.navigation,
			});
		default:
			return state;
	}
}
